import pdfMake from 'pdfmake';
import handlePurchase from "@/services/modules/purchase";
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { toCapitalizeFirst } from '@/services/utils/global.js'
pdfMake.vfs = pdfFonts.pdfMake.vfs;

pdfMake.fonts = {
    SulaimanLipi: {
        normal: 'https://fonts.cdnfonts.com/s/14639/solaimanlipi.woff',
        bold: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Medium.ttf',
        italics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Italic.ttf',
        bolditalics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-MediumItalic.ttf'
    }
}

const pdfPrinter = () => {

    const {formatCurrency, currencyToWord} = handlePurchase();
    const exportToPDF = (company, invoice, barcode = '', qrcode, userName, invoiceNotes = []) => {
        const tableItems = invoice.has_item_detail ? invoice.general : invoice.ledgers;
        var doc = {
            pageSize: 'A4',
            pageMargins: [ 60, 100, 60, 80 ],
            header: getHeader(company),
            footer: getFooter(userName, qrcode),
            content: getContent(invoice, tableItems, barcode, invoiceNotes),

            styles : {
                header: {
                    fontSize: 24,
                }
            },
            defaultStyle: {
                color: 'black',
                fontSize: 10,
                font: 'SulaimanLipi'
            },
            info: {
                title: invoice.bill_number
            }
        }

        pushIntoTable(doc, invoice, tableItems)

        const pdfDocGenerator = pdfMake.createPdf(doc);
        pdfDocGenerator.open();
    }
    const formatDate = (date) => {
        var formattedDate = date.toISOString().split('T')[0];
        var hours = date.getHours();
        var minutes = date.getMinutes();
        var amOrPm = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12 || 12;
        var formattedTime = hours + ':' + (minutes < 10 ? '0' : '') + minutes + ' ' + amOrPm;
        return formatToDdMmYy(formattedDate) + ' ' + formattedTime
    }
    const formatToDdMmYy = (date) => {
        var dat = date.split('-');
        return `${dat[2]}-${dat[1]}-${dat[0]}`;
    }
    const getHeader = (company) => {
        return {
            margin: [ 60, 25, 60, 10 ],
            columns: [
                {
                    alignment: 'left',
                    image: company.logo64,
                    maxHeight: 60
                },

                {
                    alignment: 'right',
                    stack: [
                        company.name,
                        'Address: ' + company.address,
                        'Phone: ' + company.phone,
                        'E-mail: ' + company.email,
                        'VAT Reg No: ' + company.vat_no,
                    ]
                }
            ]
        }
    }
    const getContent = (invoice, tableItems, barcode, invoiceNotes) => {
        return  [
            {
                text: 'INVOICE',
                style: 'header',
                alignment: 'center',
                margin: [0, 0, 20, 10],
                bold: true,
                color: 'black',
            },

            {
                margin: [0, 20, 0, 0],
                alignment: 'justify',
                columns: [
                    {
                        width: '50%',
                        stack: [
                            {
                                text: 'INVOICE TO',
                                color: 'black',
                                bold: true,

                            },

                            {
                                text: invoice.contact.name,
                                alignment: 'left',
                                width: '50%'
                            },

                            {
                                text: getProfileItemByField(invoice.contact.profile_items, 'address'),
                            },

                            {
                                text: getProfileItemByField(invoice.contact.profile_items, 'billing_address'),
                            },

                            {
                                text: `${invoice.contact.address ? invoice.contact.address : ''}`
                            },
                            (invoice.location_name) ? {
                                text: [
                                    {
                                        text: 'SHIP FROM: ',
                                        bold: true
                                    },

                                    {
                                        text: invoice.location_name,
                                    }
                                ],
                                margin: [0, 10, 0, 0]
                            }: ''
                        ]

                    },

                    {
                        alignment: 'right',
                        stack: [
                            {
                                text: [
                                    {
                                        text: 'DATE: ',
                                        bold: true,
                                        margin: [0, 0, 10, 0]
                                    },

                                    {
                                        text: formatToDdMmYy(invoice.date),
                                    }
                                ]
                            },
                            (invoice.sale_type_title && invoice.sale_type_title !== '') ? {
                                text: [
                                    {
                                        text: 'Sale Type: ',
                                        bold: true,
                                        margin: [0, 0, 10, 0]
                                    },

                                    {
                                        text: invoice.sale_type_title,
                                    }
                                ]
                            } : '',
                            barcode ? {
                                text: [
                                    {
                                        text: 'INVOICE REF: ',
                                        bold: true,
                                        margin: [0, 0, 10, 0]
                                    },

                                    {
                                        text: invoice.bill_number
                                    }
                                ]
                            } : '',
                            barcode ? {
                                svg: barcode
                            } : ''
                        ]
                    },
                ]
            },

            {
                style: 'tableExample',
                margin: [0, 10, 0, 0],
                table: {
                    widths: getTableWidth(tableItems),
                    body: []
                },
                layout: {
			              fillColor: function (rowIndex) {
                        return (rowIndex === 0) ? '#f3f2f7' : null;
                    },
                    hLineWidth: function () {
                        return 0.5;
                    },
                    vLineWidth: function () {
                        return 0.5;
                    }
		        }
		    },

            {
                columns: [
                    {
                        width: '55%',
                        text: [
                            {
                                text: 'In Words: ',
                                bold: true
                            },

                            {
                                text: invoice.total_amount ? currencyToWord(invoice.total_amount) : ''
                            }
                        ]
                    },
                    {
                        table: {
                            widths: ['*', '*'],
                            alignment: 'right',
                            body: formatTotals(invoice)
                        },
                        layout: {
                            hLineWidth: function () {
                                return 0.5;
                            },
                            vLineWidth: function () {
                                return 0.5;
                            }
                        }
                    }
                ],
                margin: [0, 10]
            },

            invoiceNotes.length ? {
                alignment: 'left',
                stack: formatInvoiceTerms(invoiceNotes)
            } : ''

        ]
    }
    const getTableWidth = (tableItems) => {

        const hasFreeQuantity = tableItems.find(item => item.free_quantity > 0);
        const hasTradeDiscount = tableItems.find(item => item.discount_amount > 0);
        const hasOfferDiscount = tableItems.find(item => item.offer_discount > 0);
        const hasVatAmount = tableItems.find(item => item.vat_amount > 0);

        const rowStructure = ['*', 'auto', 'auto', 'auto', 'auto'];

        if (!! hasFreeQuantity) {
            rowStructure.push('auto');
        }

        if (!! hasTradeDiscount) {
            rowStructure.push('auto');
        }

        if (!! hasOfferDiscount) {
            rowStructure.push('auto');
        }

        if (!! hasVatAmount) {
            rowStructure.push('auto');
        }

        return  rowStructure;

    }
    const getFooter = (userName, qrcode) =>{
        return {
            margin: [ 60, 0, 60, 0 ],
            columns: [
                {
                    columns: [
                        {
                            svg: qrcode
                        },

                        {
                            width: '90%',
                            alignment: 'left',
                            text: 'N.B: This is a system generated documents and requires no manual signature.',
                            margin: [5, 53, 0, 0],
                            fontSize: 8
                        }
                    ]
                },

                {
                    width: '20%',
                    alignment: 'right',
                    fontSize: 8,
                    margin: [0, 33, 0, 0],
                    stack: [
                        {
                            text: 'Printed by',
                            bold: true
                        },
                        {
                            text: userName
                        },
                        {
                            text: formatDate(new Date())
                        }
                    ]
                }
            ]
        }
    }

    const getProfileItemByField = (profile_items, keyValue) => {
        const item = profile_items.find(item => item.field === keyValue);
        return (item) ? item.value : '';
    }

    const formatTotals = (invoice) => {

        return [
            [{ text: 'Sub-total Amount', bold: true }, { text: formatCurrency(calculateSubtotal(invoice)), alignment: 'right'}],
            (invoice.vat_amount) ?
              [ { text: 'VAT Amount', bold: true }, {text:  formatCurrency(invoice.vat_amount), alignment: 'right' } ] :
               null,
            (invoice.vat_amount) ?
              [{ text: 'Total Amount', bold: true }, { text: formatCurrency(calculateSubtotal(invoice, true)), alignment: 'right'}] :
               null,
            (invoice.adjustment_amount) ?
              [ { text: 'Discount/Adjustment', bold: true }, {text:  formatCurrency(invoice.adjustment_amount), alignment: 'right' } ] : null,
            (invoice.adjustment_amount) ?
              [ { text: 'Total Invoice Amount', bold: true }, { text: formatCurrency(invoice.total_amount), alignment: 'right'}] : null,
        ].filter((item) => item !== null)
    }

    const calculateSubtotal = (invoice, withVat = false) => {
        const subTotal = invoice.subtotal_amount + (invoice.adjustment_amount ?? 0);

        if (withVat) {
            return subTotal + invoice.vat_amount;
        }

        return subTotal;
    }

    const formatInvoiceTerms = (terms) => {
        return  terms.map((item) => {
            return {
                text: `${item.full_desc}`
            }
        })
    }

    const pushIntoTable = (doc, invoice, tableItems) => {
        const hasFreeQuantity = tableItems.find(item => item.free_quantity > 0);
        const hasTradeDiscount = tableItems.find(item => item.discount_amount > 0);
        const hasOfferDiscount = tableItems.find(item => item.offer_discount > 0);
        const hasVatAmount = tableItems.find(item => item.vat_amount > 0);

        if (tableItems.length > 0) {
            const tableHeader = getTableHeader(tableItems);
            doc.content[2].table.body.push(tableHeader);
        }

        tableItems.forEach(item => {
            const rowData = getRowData(invoice, item, !!hasFreeQuantity, !!hasTradeDiscount, !!hasOfferDiscount, !!hasVatAmount);
            return doc.content[2].table.body.push(rowData);
        });
    }

    const getTableHeader = (tableItems) => {
        const hasFreeQuantity = tableItems.find(item => item.free_quantity > 0);
        const hasTradeDiscount = tableItems.find(item => item.discount_amount > 0);
        const hasOfferDiscount = tableItems.find(item => item.offer_discount > 0);
        const hasVatAmount = tableItems.find(item => item.vat_amount > 0);

        const headingRow = [
            { text: 'PARTICULARS' },
            { text: 'QTY' },
            { text: 'RATE' },
            { text: 'AMOUNT', alignment: 'right' },
            { text: 'TOTAL AMOUNT', alignment: 'right' }
        ]

        if (!! hasFreeQuantity) {
            headingRow.push({ text: 'BONUS QTY', alignment: 'right' });
        }

        if (!! hasTradeDiscount && !! hasOfferDiscount && !! hasVatAmount) {
            headingRow.splice(4, 0, ...[
                { text: 'TRADE DISCOUNT', alignment: 'right' },
                { text: 'OFFER DISCOUNT', alignment: 'right' },
                { text: 'VAT AMOUNT', alignment: 'right' },
            ]);
            return headingRow
        }

        if (!! hasVatAmount) {
            headingRow.splice(4, 0 , { text: 'VAT AMOUNT', alignment: 'right' })
        }

        if (!! hasOfferDiscount) {
            headingRow.splice(4, 0 , { text: 'OFFER DISCOUNT', alignment: 'right' })
        }

        if (!! hasTradeDiscount) {
            headingRow.splice(4, 0 , { text: 'TRADE DISCOUNT', alignment: 'right' })
        }

        return headingRow;
    }

    const getRowData = (invoice, item, hasFreeQuantity, hasTradeDiscount, hasOfferDiscount, hasVatAmount) => {
        const data = [
            {
                text: (invoice.has_item_detail ? item.product.name : item.head.name) + '\n' +
                  (item.description ? item.description : '') + '\n' +
                  (['initial','surveillance'].includes(item.sale_order_type) ?
                      toCapitalizeFirst(item.sale_order_type) : ''
                  )
            },
            { text:  invoice.has_item_detail ? formatCurrency(item.quantity) : '', alignment: 'right' },
            { text: invoice.has_item_detail ? formatCurrency(item.rate) : '', alignment: 'right' },
            { text: formatCurrency(item.quantity * item.rate), alignment: 'right' },
            { text: formatCurrency(item.total_amount), alignment: 'right' },
        ]

        if (hasFreeQuantity) {
            data.push({ text:  invoice.has_item_detail ? formatCurrency(item.free_quantity) : '', alignment: 'right' })
        }

        if (hasTradeDiscount && hasOfferDiscount && hasVatAmount) {
            data.splice(4, 0, ...[
                { text:  invoice.has_item_detail ? formatCurrency(item.discount_amount) : '', alignment: 'right' },
                { text:  invoice.has_item_detail ? formatCurrency(item.offer_discount) : '', alignment: 'right' },
                { text: formatCurrency(item.vat_amount), alignment: 'right' },
            ]);

            return data
        }

        if (hasVatAmount) {
            data.splice(4, 0 , { text: formatCurrency(item.vat_amount), alignment: 'right' })
        }

        if (hasOfferDiscount) {
            data.splice(4, 0 , { text:  invoice.has_item_detail ? formatCurrency(item.offer_discount) : '', alignment: 'right' })
        }

        if (hasTradeDiscount) {
            data.splice(4, 0 , { text:  invoice.has_item_detail ? formatCurrency(item.discount_amount) : '', alignment: 'right' })
        }

        return data;
    }

    return {
        exportToPDF
    }
}

export default pdfPrinter;
